import React from 'react';
import { useSelector } from 'react-redux';
import {
    isShowBreakpointsState,
    isShowPolygonBreakpointsState,
    singlePolygonCoordsState,
} from '../../../../../app/redux/retrievers/retrievers';
import { Popup } from 'react-leaflet';

const PolygonBreakpoints = () => {
    const singlePolygonCoords = useSelector(singlePolygonCoordsState);
    const isBreakpointsActive = useSelector(isShowBreakpointsState);
    const isShowPolygonBreakpoints = useSelector(isShowPolygonBreakpointsState);

    return isShowPolygonBreakpoints || isBreakpointsActive ? (
        <>
            {singlePolygonCoords.map((coord: any, index: number) => {
                // return index === singlePolygonCoords.length ? (
                //     ''
                // ) :
                return (
                    <Popup
                        key={index}
                        position={coord}
                        closeButton={false}
                        autoClose={false}
                        closeOnClick={false}
                        maxWidth={1}
                        minWidth={1}
                        className="polygon-breakpoint"
                    >
                        {index + 1}
                    </Popup>
                );
            })}
        </>
    ) : (
        <></>
    );
};

export default PolygonBreakpoints;
